<!--  -->
<template>
    <div class="roadcontainer">
        <h3><span> {{isEnglish ? 'All route planning':'全部路线规划'}} </span></h3>
        <div class="main">
            <ul>
                <li  v-for="(v,i) in tourInfo" :key="i" @click="lineMsg(i)">
                    <p>
                        {{isEnglish ?v.name_eng: v.name}}  
                    </p>
                    <p class="time">
                        {{v.tourCount ?v.tourCount  :''}}
                    </p>
                    <iconx  type="jiantou" /> 
                </li>
            </ul>
        </div>
 
    </div>


</template>
<script>
import iconx from "@/components/iconx.vue";
import eventBus from "@/utils/eventBus";

export default {
    name:"roadLine",
    components:{
        iconx,
        
    },
    props:{
        closeLineRoad:{
            type:Function
        },
        openLine:{
            type:Function

        },
        choseLine:{
            type:Function
        },
        isEnglish:{
            type:Boolean
        }
    },
    data() {
        return {
            tourInfo:{},
            lineDialog:false,
            tabCheck:0
        }
    },
    created() {
         this.tourInfo=JSON.parse(localStorage.getItem("tourInfo")).path_planning
    },
    mounted() {
        console.log(this.isEnglish)
    },
    methods:{
        lineMsg(id){
            this.tabCheck=id
            this.lineDialog=true
            eventBus.emit("setLineVis", id);
             eventBus.emit("lineTour",this.tourInfo[id].bitchIds)
            this.$emit("closeLineRoad",false)
            this.$emit("openLine",true)
            this.$emit("choseLine",id)

        },
        closeDialog(data){
            this.lineDialog=data
        }
    }
}
</script>
<style scoped lang="scss">
    .roadcontainer{
        width: 100%;
        height: 100%;
        position: fixed;
        background: #fff;
        top: 0; 
        z-index: 99999;
        h3{
             padding: .3rem;
        box-sizing: border-box;
            font-size: 20px;
            font-weight: normal;
            color: #555;
            span{
                border-bottom: 5px solid 	#FFD700;
            }
        }
        .main{
            flex: 1;
            // display: flex;
            >ul{
                width: 100%;
                height: auto;
                margin-top: .2rem;
                 padding: .2rem .3rem 0;
               
                border-top: 1px solid #eee;
                box-sizing: border-box;

                >li{
                    list-style: none;
                    width: 100%;
                    height: auto;
                    font-size: 18px;
                    border-bottom: 1px solid #eee ;
                    padding: 10px 0;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    position: relative;
                    i{
                        position: absolute;
                        right: 0;
                    }
                }
                .time{
                    font-size: 12px;
                    color: #777;
                }
            }
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/tourLineRoad.vue